"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getFullHref = exports.replace = exports.navigateTo = void 0;

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _history = require("history");

var _Urls = require("./Urls");

var history = (0, _history.createBrowserHistory)({
  basename: (0, _Urls.getAppRoot)()
});

var navigateTo = function navigateTo() {
  (0, _invariant.default)(history, 'history not initialized');
  return history.push.apply(history, arguments);
};

exports.navigateTo = navigateTo;

var replace = function replace() {
  (0, _invariant.default)(history, 'history not initialized');
  return history.replace.apply(history, arguments);
};

exports.replace = replace;

var getFullHref = function getFullHref(to) {
  var includeProtocol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  (0, _invariant.default)(history, 'history not initialized');
  var _window$location = window.location,
      protocol = _window$location.protocol,
      hostname = _window$location.hostname;
  var location = typeof to === 'string' ? (0, _history.createLocation)(to, null, null, history.location) : to;
  var href = history.createHref(location);
  return "" + (includeProtocol ? protocol + "//" : '') + hostname + href;
};

exports.getFullHref = getFullHref;
var _default = history;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./js/util/History.js
// module id = 27
// module chunks = 0